import useSWR, { SWRResponse } from "swr";
import { IFund } from "../../types/api/IFund";
import { IFundFetcherResponse, IUseFundList } from "./types";
import commonSwrConfig from "../commonSwrConfig";
import { mapFund } from "../useFund/helper";
import { useSession } from "@portal/auth/client/SessionProvider";

export const fundListFetcher = async (url: URL): Promise<IFundFetcherResponse> => {
  const response = await fetch(url, {
    method: "GET",
    headers: [["accepts", "application/json"]],
  });

  if (response.status !== 200) {
    throw response.status;
  }

  const json = await response.json();
  const funds = json.map((f: IFund) => mapFund(f));

  return { funds, allFunds: funds };
};

const useFundList: IUseFundList = () => {
  const { update } = useSession();

  const response: SWRResponse<IFundFetcherResponse, unknown> = useSWR(`/api/funds`, fundListFetcher, commonSwrConfig(update));
  const getFund = (isin?: string) => {
    if (!isin) return undefined;
    return response.data?.allFunds.find(fund => fund.isin === isin);
  };

  return {
    allFunds: response.data?.allFunds,
    getFund,
    error: response.error,
    isLoading: !response.data && !response.error,
  };
};

export default useFundList;
